import { render, staticRenderFns } from "./permission-maintenance.vue?vue&type=template&id=a649d332&"
import script from "./permission-maintenance.vue?vue&type=script&lang=js&"
export * from "./permission-maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports